module.exports = __webpack_public_path__ + "img/company.de44b896.svg";